// @flow
export const PAYMENT_METHODS_UPDATE_FETCH = 'PAYMENT_METHODS_UPDATE_FETCH'
export const PAYMENT_METHODS_UPDATE_SUCCESS = 'PAYMENT_METHODS_UPDATE_SUCCESS'
export const PAYMENT_METHODS_UPDATE_FAIL = 'PAYMENT_METHODS_UPDATE_FAIL'
